import type { ApiError } from "@/api/client";
import { STRINGS } from "@/constants/strings";

const S = STRINGS.tenant;

export type ClinicalAssignmentMutationKind = "create" | "delete";

/**
 * Maps API-014 / API-015 error codes and statuses to tenant UI strings.
 * Only used when mutation meta marks the call as a clinical-assignment mutation.
 */
export function clinicalAssignmentMutationErrorMessage(
  error: ApiError,
  kind: ClinicalAssignmentMutationKind,
): string | null {
  if (kind === "create") {
    if (error.code === "TENANT_NOT_FOUND") {
      return S.clinicalAssignmentErrorClinicalTenantNotFound;
    }
    if (error.code === "ASSIGNMENT_EXISTS") {
      return S.clinicalAssignmentErrorAssignmentExists;
    }
    return null;
  }
  if (kind === "delete") {
    if (error.status === 404) {
      return S.clinicalAssignmentErrorRemoveNotPossible;
    }
    return null;
  }
  return null;
}
